
export default {
    name: "leaderboard_prize",
    data(){
        return {
            isLoading: true,
            selectedLang: "en",

            langText: {
                en: {
                    title: "Prizes and Scoring Mechanics",
                    desc: "There are plenty of ways to be rewarded throughout MyWellness Fiesta! Get your colleagues on board — not only will the top 1,500 participants be rewarded, there are Group and referral-based prizes to be won as well.",

                    group_leaderboard_position: "Group leaderboard position",
                    solo_leaderboard_position: "Solo leaderboard position",
                    referrer_leaderboard_position: "Top referrer awards (by number of referrals)",
                    prizes_text: "Prize",
                    activity: "Activity",
                    points: "Points",

                    group_prizes: [
                        { title: "Top 50", value: "S$150 per group" },
                    ],
                    
                    solo_prizes: [
                        { title: "1st", value: "S$150" },
                        { title: "2nd", value: "S$120" },
                        { title: "3rd", value: "S$100" },
                        { title: "4th - 10th", value: "S$80" },
                        { title: "11th - 20th", value: "S$50" },
                        { title: "21st - 100th", value: "S$30" },
                        { title: "101st - 1500th", value: "S$10" },
                    ],

                    referrer_prizes: [
                        { title: "1st", value: "S$80" },
                        { title: "2nd", value: "S$50" },
                        { title: "3rd", value: "S$30" },
                    ],

                    activities: [
                        { 
                            title: "Refer a friend to join MyWellness Fiesta and enjoy the fun together!", 
                            value: "Earn 20 points per successful referral"
                            // value: "Get up to 50 points per session watched<br>(On-demand recordings available for most talks)"
                        },
                        { 
                            title: "Visit MyWellness Fiesta daily and keep your streak going!", 
                            value: "Earn 10 points per daily login, plus up to 500 bonus points for login streaks"
                        },
                        { 
                            title: "Make your Tunetopian uniquely yours by customising your avatar!", 
                            value: "Earn 50 points upon completion"
                        },
                        { 
                            title: "Download your personalised Tunetopian GIF and share the Fiesta spirit!", 
                            value: "Earn 50 points on your first download"
                        },
                        { 
                            title: "Come back in Week 4 to discover new Tunetopians, accessories and GIF backgrounds!", 
                            value: "Earn 100 points when the Expansion Pack is released"
                        },
                        { 
                            title: "Explore Tunetopia and discover more about each MyWellness pillar!", 
                            value: "Earn 10 points per festival signage explored, up to 50 points"
                        },
                        { 
                            title: "Build the Beat and see how high you can stack!", 
                            value: "Earn 10 points for your daily play, plus bonus points for placing on the weekly leaderboard."
                        },
                        { 
                            title: "Visit the Fiesta Jukebox and add to your collection!", 
                            value: "Play for chances to win up to 35 bonus points"
                        },
                        { 
                            // title: "The hunt keeps moving! Find the same hidden items in new hiding spots across Tunetopia every Monday and Thursday at 12 a.m. (SGT).", 
                            title: "Hunt down the hidden items across Tunetopia! New hidden items in new hiding spots — refreshed every Monday and Thursday (12 a.m GMT).", 
                            value: "Earn up to 300 points across the Fiesta"
                        },
                        { 
                            title: "Tune in to MyWellness talks and workshops to learn something new!", 
                            value: "Earn 50 points per eligible session attended or viewed"
                        },
                        { 
                            title: "Get moving and join a MyWellness fitness session!", 
                            value: "Earn 50 points per eligible session attended"
                        },
                        { 
                            title: "Explore useful resources in the MyWellness Programme Hub.", 
                            value: "Earn 10 points per eligible resource accessed"
                        },
                        { 
                            title: "Download a MyWellness resource to keep for later.", 
                            value: "Earn 100 points per eligible resource downloaded"
                        },
                        { 
                            title: "Tell us what you thought of MyWellness Fiesta! - through the <button class='text-theme' onclick='const hiddenPopup = document.getElementById(`hidden_popup`); hiddenPopup.dataset.popup = `user_survey`; hiddenPopup.dataset.source = `leaderboard`; hiddenPopup.click()''>User Survey</button>.", 
                            value: "Earn 110 points upon completion of the User Survey"
                            // value: "Receive 100 points after completion<br>Survey goes live on 15 Oct"
                        },
                        
                    ],
                },
                cn: {
                    title: "奖品和评分机制",
                    desc: "本次活动的获奖方式比以往更加丰富！邀请好友一同参与吧！不仅排名前 1,500 位的参与者可获得奖励，还设有团队奖和邀请奖。",

                    group_leaderboard_position: "团体排行榜名次",
                    solo_leaderboard_position: "个人排行榜名次",
                    referrer_leaderboard_position: "最佳邀请人奖励（按成功邀请人数排名）",
                    prizes_text: "奖品",
                    activity: "活动",
                    points: "积分",

                    group_prizes: [
                        { title: "前 50 名", value: "每个团体 150 新元" },
                    ],
                    
                    solo_prizes: [
                        { title: "第 1 名", value: "150 新元" },
                        { title: "第 2 名", value: "120 新元" },
                        { title: "第 3 名", value: "100 新元" },
                        { title: "第 4 名至第 10 名", value: "80 新元" },
                        { title: "第 11 名至第 20 名", value: "50 新元" },
                        { title: "第 21 名至第 100 名", value: "30 新元" },
                        { title: "第 101 名至第 1500 名", value: "10 新元" },
                    ],

                    referrer_prizes: [
                        { title: "第 1 名", value: "80 新元" },
                        { title: "第 2 名", value: "50 新元" },
                        { title: "第 3 名", value: "30 新元" },
                    ],

                    activities: [
                        { 
                            title: "邀请好友加入嘉年华，一同畅享活动乐趣！", 
                            value: "每成功邀请 1 名好友可获 20 积分"
                        },
                        { 
                            title: "每日登录健康嘉年华，保持连续登录记录！", 
                            value: "每日登录可获 10 积分，连续登录还可额外获得最高 500 积分"
                        },
                        { 
                            title: "自定义专属头像，打造独一无二的音律乐园形象！", 
                            value: "完成自定义即可获得 50 积分"
                        },
                        { 
                            title: "下载专属音律乐园动态贴图，分享嘉年华活力！", 
                            value: "首次下载可获 50 积分"
                        },
                        { 
                            title: "第 4 期活动开启后，解锁全新音律乐园形象、配饰及动态背景贴图！", 
                            value: "拓展包上线时可获 100 积分"
                        },
                        { 
                            title: "探索嘉年华场景，深入了解各项健康维度内容！", 
                            value: "每探索 1 个嘉年华场景标识可获 10 积分，此项最高累计 50 积分"
                        },
                        { 
                            title: "参与音律闯关挑战，冲击更高积分排名！", 
                            value: "每日参与挑战可获 10 积分，登上每周排行榜可额外斩获奖励积分"
                        },
                        { 
                            title: "参与嘉年华音乐专区活动，丰富你的藏品库！", 
                            value: "参与游戏即有机会赢取最多 35 积分"
                        },
                        { 
                            // title: "探索音律乐园，寻觅全部隐藏道具！", 
                            title: "探索音律乐园，寻觅全部隐藏道具！隐藏物品会更换新位置，每周一、周四凌晨 12 点（格林尼治标准时间）刷新。", 
                            value: "活动期间累计最多可获 300 积分"
                        },
                        { 
                            title: "观看健康主题讲座与工作坊，学习全新健康知识！", 
                            value: "每参加或观看 1 场符合条件的活动可获 50 积分"
                        },
                        { 
                            title: "积极运动，参加健身课程！", 
                            value: "每参与 1 场有效健身课程可获 50 积分"
                        },
                        { 
                            title: "浏览健康活动中心的实用资源内容。", 
                            value: "每浏览 1 份有效资源可获 10 积分"
                        },
                        { 
                            title: "下载健康资源，随时留存查阅。", 
                            value: "每下载 1 份有效资源可获 100 积分"
                        },
                        { 
                            title: "参与调研，分享你对本次健康嘉年华的体验与看法！", 
                            value: "完成用户调研问卷即可获得 110 积分"
                        },
                    ],
                }
            }
        }
    },
    computed: {

    },
    mounted(){
        
    },
    methods: {
        
    },
    watch: {
        "selectedLang"(){
            this.$emit("update:selectedLang", this.selectedLang);
        }
    }
}
